/*eslint-disable*/
import { useGet } from "./useRequest";
export function downloadAllDocuments(candidateId, jobId) {
    const path = `/DownloadAllDocumentsForCandidate?candidateId=${candidateId}&jobId=${jobId}`;
    return useGet(path);
}


export const getDocumentUrl =(documentId) => {
    const path = "/documents/" + documentId + "/file";
    return useGet(path);
};
